import styled from 'styled-components';
import { MAX_Z_INDEX } from '../../../theme/theme';

export const ClientsPopover = styled.ul(({ theme }) => ({
  position: 'absolute',
  boxShadow: theme.shadows['500'],
  border: `1px solid ${theme.colors.neutral['200']}`,
  borderRadius: theme.radii.medium,
  background: theme.colors.bg,
  boxSizing: 'border-box',
  margin: '6px 0',
  padding: '8px 0',
  zIndex: MAX_Z_INDEX,
  width: '100%',
  listStyleType: 'none',
  maxHeight: 'min(36vh, 370px)',
  overflowY: 'auto',

  '@media (min-width: 700px)': {
    minWidth: 600,
  },
}));
